export default "__VITE_ASSET__8f6fec5d__"